import { brandfolderColorPalette } from '@brandfolder/react';
import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import { Person } from '../customPeopleTagTypes';

const SuggestedList = styled.ul`
  background-color: ${brandfolderColorPalette.neutrals[0]};
  box-shadow: 1px 2px 6px 0 rgba(0, 0, 0, 0.09);
  border-radius: 4px;
  list-style: none;
  padding: 8px;
  position: absolute;
  margin-top: 2px;
  z-index: 2;

  .autocomplete-option {
    font-size: 14px;

    &-image {
      border-radius: 40px;
      height: 40px;
      margin-right: 12px;
      width: 40px;
    }

    &-button {
      align-items: center;
      background-color: transparent;
      border: none;
      display: flex;

      padding: 8px;
      text-align: left;
      width: 100%;
      gap: 4px;

      .autocomplete-option-tag-count {
        color: ${brandfolderColorPalette.neutrals[400]};
        font-size: 14px;
        font-weight: 400;
      }

      &:hover {
        background-color: ${brandfolderColorPalette.neutrals[100]};
        border-radius: 4px;
      }
    }
  }
`;

interface SuggestedNamesListProps {
  handleOnSelectTargetPerson: (person: Person) => void;
  handleCreateNewPerson?: (typedName: string) => void;
  suggestions: Person[];
  typedName?: string;
  showCreateOption?: boolean;
  listClasses?: string;
}

const CreateOption = styled.li`
  .create-option-button {
    align-items: center;
    background-color: transparent;
    border: none;
    display: flex;
    gap: 8px;
    padding: 8px;
    text-align: left;
    width: 100%;
    font-size: 14px;

    &:hover {
      background-color: ${brandfolderColorPalette.neutrals[100]};
      border-radius: 4px;
    }
  }
`;

export const SuggestedNamesList: FunctionComponent<SuggestedNamesListProps> = ({
  suggestions,
  handleOnSelectTargetPerson,
  handleCreateNewPerson,
  typedName,
  showCreateOption = false,
  listClasses = null
}) => {
  const hasSuggestions = suggestions?.length > 0;
  const canCreateNewPerson = showCreateOption && typedName?.trim() && handleCreateNewPerson;
  const shouldShowList = hasSuggestions || canCreateNewPerson;

  if (!shouldShowList) {
    return null;
  }

  return (
    <SuggestedList className={listClasses}>
      {canCreateNewPerson && (
        <CreateOption>
          <button
            className="create-option-button"
            onClick={(): void => handleCreateNewPerson(typedName.trim())}
            type="button"
          >
            <span>Create "{typedName.trim()}"</span>
          </button>
        </CreateOption>
      )}
      {suggestions.map((person) => (
        <li key={person.face_uri} className="autocomplete-option">
          <button
            className="autocomplete-option-button"
            id={person.person_id}
            onClick={(): void => handleOnSelectTargetPerson(person)}
            type="button"
          >
            <img alt="person thumbnail" className="autocomplete-option-image" src={person.face_uri} />
            <span>{person.tag_name}</span>
            {person.face_count ? <span className="autocomplete-option-tag-count">{person.face_count}</span> : null}
          </button>
        </li>
      ))}
    </SuggestedList>
  );
};
